import styled from 'styled-components';

import { useContent } from '../../content/load';
import { Pulse } from '../primitives/Pulse';

const Bar = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: ${(p) => p.theme.step[5]}px;
  padding: 10px ${(p) => p.theme.layout.gutter}px;
  border-bottom: 1px solid ${(p) => p.theme.color.border.faint};
  background: ${(p) => p.theme.color.bg[1]};
  font-family: ${(p) => p.theme.font.mono};
  font-size: ${(p) => p.theme.step[1]}px;
  color: ${(p) => p.theme.color.text[2]};
`;

const Item = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
`;

const Value = styled.span`
  color: ${(p) => p.theme.color.text[0]};
`;

export function StatusBar() {
  const { site } = useContent();
  if (!site.statusBar?.length) return null;
  return (
    <Bar>
      {site.statusBar.map((s) => (
        <Item key={s.label}>
          {s.kind === 'indicator' && <Pulse />}
          <span>{s.label}</span>
          <Value>{s.value}</Value>
        </Item>
      ))}
    </Bar>
  );
}
